module.exports = __webpack_public_path__ + "5ef146385f920bb4a8f8c6a31b830037.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/MN.svg
// module id = oNrs
// module chunks = 0